import { Component, Vue, Watch } from 'vue-property-decorator';

import Array from '@/components/array/array.vue';
import ArrayFaq from '@/components/arrayFaq/arrayFaq.vue';
import Group from '@/components/group/group.vue';
import Partners from '@/components/partners/partners.vue';
import Single from '@/components/single/single.vue';

@Component({
    components: {
        Array,
        ArrayFaq,
        Group,
        Partners,
        Single,
    },
    metaInfo() {
        return {
            title: 'About the project',
        };
    },
})
export default class Project extends Vue {
    timeout!: number;

    toLoad = 9;

    @Watch('$route.hash')
    hashChanged() {
        if (this.$route.hash !== '#top') {
            this.scrollTo();
        }
    }

    load() {
        this.toLoad--;

        if (this.toLoad === 0) {
            this.scrollTo();
        }
    }

    scrollTo() {
        if (this.timeout) {
            window.clearInterval(this.timeout);
        }

        this.timeout = window.setTimeout(() => {
            if (this.$route.hash) {
                (this as any).$scrollTo(this.$route.hash, 500, {
                    offset: 0,
                });
            }
        }, 100);
    }
}
